// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ToastViewport {
    --viewport-padding: 25px;
    position: fixed;
    bottom: 0;
    right: 0;
    display: flex;
    flex-direction: column;
    padding: var(--viewport-padding);
    gap: 10px;
    width: 390px;
    max-width: 100vw;
    margin: 0;
    list-style: none;
    z-index: 2147483647;
    outline: none;
}

.ToastRoot {
    background-color: white;
    border-radius: 6px;
    box-shadow:
            hsl(206 22% 7% / 35%) 0px 10px 38px -10px,
            hsl(206 22% 7% / 20%) 0px 10px 20px -15px;
    padding: 15px;
    display: grid;
    grid-template-areas: "title action" "description action";
    grid-template-columns: auto max-content;
    column-gap: 15px;
    align-items: center;
    font-weight: bold;
}
.ToastRoot[data-state="open"] {
    animation: slideIn 150ms cubic-bezier(0.16, 1, 0.3, 1);
}
.ToastRoot[data-state="closed"] {
    animation: hide 100ms ease-in;
}
.ToastRoot[data-swipe="move"] {
    transform: translateX(var(--radix-toast-swipe-move-x));
}
.ToastRoot[data-swipe="cancel"] {
    transform: translateX(0);
    transition: transform 200ms ease-out;
}
.ToastRoot[data-swipe="end"] {
    animation: swipeOut 100ms ease-out;
}
.ToastDescription {
    display: flex;
}
.ToastDescription svg {
    width: 20px;
    margin-right: 10px;
}

@keyframes hide {
    from {
        opacity: 1;
    }
    to {
        opacity: 0;
    }
}

@keyframes slideIn {
    from {
        transform: translateX(calc(100% + var(--viewport-padding)));
    }
    to {
        transform: translateX(0);
    }
}

@keyframes swipeOut {
    from {
        transform: translateX(var(--radix-toast-swipe-end-x));
    }
    to {
        transform: translateX(calc(100% + var(--viewport-padding)));
    }
}

.rt-Button svg {
    height: 100%
}

@media (min-width: 1000px) {
    .main-content {
        min-height: 500px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;IACI,wBAAwB;IACxB,eAAe;IACf,SAAS;IACT,QAAQ;IACR,aAAa;IACb,sBAAsB;IACtB,gCAAgC;IAChC,SAAS;IACT,YAAY;IACZ,gBAAgB;IAChB,SAAS;IACT,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB;;qDAEiD;IACjD,aAAa;IACb,aAAa;IACb,wDAAwD;IACxD,uCAAuC;IACvC,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;AACrB;AACA;IACI,sDAAsD;AAC1D;AACA;IACI,6BAA6B;AACjC;AACA;IACI,sDAAsD;AAC1D;AACA;IACI,wBAAwB;IACxB,oCAAoC;AACxC;AACA;IACI,kCAAkC;AACtC;AACA;IACI,aAAa;AACjB;AACA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI;QACI,UAAU;IACd;IACA;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,2DAA2D;IAC/D;IACA;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,qDAAqD;IACzD;IACA;QACI,2DAA2D;IAC/D;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ","sourcesContent":[".ToastViewport {\n    --viewport-padding: 25px;\n    position: fixed;\n    bottom: 0;\n    right: 0;\n    display: flex;\n    flex-direction: column;\n    padding: var(--viewport-padding);\n    gap: 10px;\n    width: 390px;\n    max-width: 100vw;\n    margin: 0;\n    list-style: none;\n    z-index: 2147483647;\n    outline: none;\n}\n\n.ToastRoot {\n    background-color: white;\n    border-radius: 6px;\n    box-shadow:\n            hsl(206 22% 7% / 35%) 0px 10px 38px -10px,\n            hsl(206 22% 7% / 20%) 0px 10px 20px -15px;\n    padding: 15px;\n    display: grid;\n    grid-template-areas: \"title action\" \"description action\";\n    grid-template-columns: auto max-content;\n    column-gap: 15px;\n    align-items: center;\n    font-weight: bold;\n}\n.ToastRoot[data-state=\"open\"] {\n    animation: slideIn 150ms cubic-bezier(0.16, 1, 0.3, 1);\n}\n.ToastRoot[data-state=\"closed\"] {\n    animation: hide 100ms ease-in;\n}\n.ToastRoot[data-swipe=\"move\"] {\n    transform: translateX(var(--radix-toast-swipe-move-x));\n}\n.ToastRoot[data-swipe=\"cancel\"] {\n    transform: translateX(0);\n    transition: transform 200ms ease-out;\n}\n.ToastRoot[data-swipe=\"end\"] {\n    animation: swipeOut 100ms ease-out;\n}\n.ToastDescription {\n    display: flex;\n}\n.ToastDescription svg {\n    width: 20px;\n    margin-right: 10px;\n}\n\n@keyframes hide {\n    from {\n        opacity: 1;\n    }\n    to {\n        opacity: 0;\n    }\n}\n\n@keyframes slideIn {\n    from {\n        transform: translateX(calc(100% + var(--viewport-padding)));\n    }\n    to {\n        transform: translateX(0);\n    }\n}\n\n@keyframes swipeOut {\n    from {\n        transform: translateX(var(--radix-toast-swipe-end-x));\n    }\n    to {\n        transform: translateX(calc(100% + var(--viewport-padding)));\n    }\n}\n\n.rt-Button svg {\n    height: 100%\n}\n\n@media (min-width: 1000px) {\n    .main-content {\n        min-height: 500px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
